import { render, staticRenderFns } from "./dropdown.html?vue&type=template&id=2b715c5a&scoped=true&"
import script from "./dropdown.js?vue&type=script&lang=js&"
export * from "./dropdown.js?vue&type=script&lang=js&"
import style0 from "./dropdown.scss?vue&type=style&index=0&id=2b715c5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b715c5a",
  null
  
)

export default component.exports